import type { FC } from 'react';
import React from 'react';
import { Grid } from '@alfa-bank/site-grid-universal';
import { ImgV2 as Img } from '@alfa-bank/site-img-v2';
import { AssetCardDesktop as Card } from '@alfa-bank/site-invest-mediaportal-common/components/asset-card-desktop';
import { TextDesktop as Text } from '@alfa-bank/site-text-v2/desktop';
import { translateISODateToString } from '@alfa-bank/site-invest-common/helpers/date/translate-iso-date-to-string';
import { sendEvent } from '@alfa-bank/site-helpers-common/browser/send-event';
import cn from 'classnames';

import { LinkSharingDesktop as LinkSharing } from '../../link-sharing/desktop';
import type { IArticleHeaderProps } from '../models';
import { getGridColumnsWidths } from '../../../helpers/common';

import styles from './styles.css';

export const ArticleHeaderDesktop: FC<IArticleHeaderProps> = ({
    analytics,
    article,
    baseUrlToAsset,
    image,
}) => {
    const onClickAsset = (assetName: string) => () => {
        sendEvent({ ...analytics?.clickOnAsset, label_detail: assetName });
    };

    return (
        <>
            <Grid
                collapse
                columnsWidth={getGridColumnsWidths(image?.link)}
                dataTestId="article-header-desktop"
                styler={{ marginBottom: 40 }}
            >
                <>
                    <Text
                        kind="secondary"
                        styler={{ marginBottom: 16, marginTop: 0 }}
                        view="primary-medium"
                    >
                        {`${article.category.description} • ${translateISODateToString(
                            article.publicationDate,
                            { convertToMoscowDate: true }
                        )}`}
                    </Text>
                    <Text kind="primary" styler={{ margin: 0 }} tag="h1" view="large">
                        {article.title}
                    </Text>
                    {article.description && (
                        <Text styler={{ marginTop: 24, marginBottom: 24 }} view="primary-large">
                            {article.description}
                        </Text>
                    )}
                    <>
                        {article.assets?.map(asset => (
                            <Card
                                key={asset.ISIN}
                                asset={asset}
                                baseUrlToAsset={baseUrlToAsset}
                                onClickAsset={onClickAsset}
                            />
                        ))}
                    </>
                </>
                <></>
                {!!image?.link && (
                    <Img
                        className={cn(styles.external, styles.articleImg)}
                        dataTestId="article-header-main-image"
                        height={image.height}
                        src={image.link}
                        width={image.width}
                    />
                )}
            </Grid>

            <Grid alignment="center" colAutoWidth justify="between" styler={{ paddingBottom: 16 }}>
                <LinkSharing
                    analytics={{ shareLink: analytics?.shareArticleBody }}
                    title={article.title}
                    url={article.shareLinkUri}
                />
            </Grid>
        </>
    );
};
